import styled from "@emotion/styled";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PreviewProps, PreviewType, TabStatesProps } from "../../../../types/dataTypes";
import { PREVIEW_BANNER } from "../../../../constants/icons/PreviewBanner";
import { useState } from "react";
import { useGetContactableMailCountQuery, useLazyGetAlreadyContactedMailCountQuery, usePostAiEmailMutation, usePostRephraseEmailMutation } from "../../../../redux/services/folderName";
import { LEFT_DISABLED, LEFT_ENABLE, RIGHT_DISABLED, RIGHT_ENABLE } from "../../../../constants/icons/ArrowIcon";
import { setContentPersonalisationGenratedViaAI, setPreviewNo, setPreviews } from "../../../../redux/slice/campaignSlice";
import { display } from "@mui/system";
import Button from "@mui/material/Button";
import { ChannelInfo, getChannelId, getCurrencyFromHexCode, getCurrencySymbol, getFounditDomain, getHexCodeFromCurrency, replaceDetails, returnSingularOrPlural, updateCampaignPlaceholderValues} from "../../../../utils/helpers";
import React from "react";
import AppDownloadBanner from "../../../../constants/icons/AppDownloadBanner";

const Container = styled.div`
  max-width: 667px;
  margin-top: 55px;
  font-family: Noto Sans;
`

const Title = styled.div`
  padding: 1.3rem 1.6rem;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.6rem;
  color: ${COLOR_MAP.LIGHT_GREY};
  border-bottom: 1px solid ${COLOR_MAP.BORDER_GREY};
  display: flex;
  justify-content: space-between;
`

const EmailHeading = styled.div`
  position: absolute;
  top: 155px;
  left: 27px;
  color: #FFF;
  font-family: Noto Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  text-transform: capitalize;
`

const PreviewEmail = () => {
  const [domain, setDomain] = React.useState('foundit.in');
  const previews = useSelector((state: RootState) => state.campaign.previewState);
  const previewNo = useSelector((state: RootState) => state.campaign.previewNo);


  const companyName = useSelector((state: RootState) => state.campaign.companyName);
  const originalCompanyName = useSelector((state: RootState) => state.campaign.originalCompanyName);
  const aboutCompany = useSelector((state: RootState) => state.campaign.aboutCompany);
  const minExperience = useSelector((state: RootState) => state.campaign.minExperience);
  const maxExperience = useSelector((state: RootState) => state.campaign.maxExperience);
  const jobTitle = useSelector((state: RootState) => state.campaign.jobTitle);
  const jobLocations = useSelector((state: RootState) => state.campaign.jobLocation)
  const minSalary = useSelector((state: RootState) => state.campaign.minSalary);
  const maxSalary = useSelector((state: RootState) => state.campaign.maxSalary);
  const tabState = useSelector((state: RootState) => state.campaign.tabState);
  const selectedTab = useSelector((state: RootState) => state.campaign.selectedTab);
  const media = useSelector((state: RootState) => state.campaign.mediaList);
  const currency = useSelector((state: RootState) => state.campaign.currency);
  const jobMode = useSelector((state: RootState) => state.campaign.jobMode)
  const jobDescription = useSelector((state: RootState) => state.campaign.jobDescription);
  const signature = useSelector((state: RootState) => state.campaign.signature);
  const siteContext = useSelector((state: RootState) => state.campaign.userData.siteContext);

  const isSeaAndGulf = siteContext === 'rexmonster' ? false : true;

  const jdLink = useSelector((state: RootState) => state.campaign.jobDescription);
  const { isBulkCampaign, campaignInitiationId } = useSelector((state: RootState) => state.campaign.campaignCreationQueryData);
  const isBulk = isBulkCampaign;
  const { contentPersonalisationGenratedViaAI, contentPersonalisationType } = useSelector((state: RootState) => state.campaign);
  const { data: contactableMailDetails } = useGetContactableMailCountQuery(campaignInitiationId, {skip : !campaignInitiationId});
  const contactableCount = contactableMailDetails?.contactableCount || 1;

  const selectedTabData = tabState.find((tab: TabStatesProps) => tab.label === selectedTab) || tabState[0];
  const [postAiEmail] = usePostAiEmailMutation();
  const [postRephraseEmail] = usePostRephraseEmailMutation();

  // const [previewNo, setPreviewNo] = useState(1)

  const selectedFollowupTab = selectedTab.includes('Follow up-') ? Number(selectedTab.substring(10)) : 1
  const [previewFollowUpNo, setPreviewFollowUpNo] = useState(selectedFollowupTab)

  const dispatch = useDispatch();

  const currencySymbol = getCurrencySymbol(currency);

  const searchParams = new URLSearchParams(window.location.search);
  const cn = searchParams.get('cn') as string
  const { domain: requiredDomain } : ChannelInfo = getChannelId(cn)

  const handlePreviewNavigate = (direction: 'prev' | 'next') => {
    if (direction === 'prev') {

      if (selectedTabData.label !== 'Email') {
        if (previewFollowUpNo === 1) return
        setPreviewFollowUpNo(previewFollowUpNo - 1)
      }
      else {
        if (previewNo === 1) return
        dispatch(setPreviewNo(previewNo - 1))
      }
    }
    else {
      if (selectedTabData.label !== 'Email') {
        if (previewFollowUpNo === tabState.length - 1) return;
        setPreviewFollowUpNo(previewFollowUpNo + 1)

      } else {

        // if (previewNo === contactableCount) return;
        if (previewNo === contactableCount || !contentPersonalisationGenratedViaAI) return;
        if (previews?.filter(i => i.previewNumber === previewNo + 1).length) { dispatch(setPreviewNo(previewNo + 1)); return; }
        if (contentPersonalisationType) {
          handlePreviewWithoutAI()
        } else {
          handlePreviewWithAI()
        }
      }
    }
  }

  const handlePreviewWithAI = () => {
    postAiEmail({
      campaignInitiationId,
      previewProfileNo: previewNo + 1,
      isInitiationRequest: false
    })
      .unwrap()
      .then((res: { mailContent: { salutation: string; body: string; }; }) => {
        dispatch(setContentPersonalisationGenratedViaAI({ contentPersonalisationGenratedViaAI: 1 }))
        if (res) {
          const msg = res?.mailContent?.salutation + res?.mailContent?.body?.replaceAll("\\n", "<br>");
          dispatch(setPreviews({ previewState: [...previews, { email: msg, previewNumber: previewNo + 1 }] }))
          // setPreviews([...previews, { email: msg, previewNumber: previewNo + 1 }])
          dispatch(setPreviewNo(previewNo + 1))
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
  }

  const handlePreviewWithoutAI = () => {
    postRephraseEmail({
      payload:{
      alreadyViewedKeys: [],
      campaignInitiationId,
      followUp: 0,
      type: "REPHRASE",
      previewProfileNo: previewNo + 1,
      isInitiationRequest: false
    },
  domain:requiredDomain
  })
      .unwrap()
      .then((res: { mailContent: { salutation: string; body: string; }; }) => {
        dispatch(setContentPersonalisationGenratedViaAI({ contentPersonalisationGenratedViaAI: 1 }))
        if (res) {
          const msg = res?.mailContent?.salutation + res?.mailContent?.body?.replaceAll("\\n", "<br>");
          dispatch(setPreviews({ previewState: [...previews, { email: msg, previewNumber: previewNo + 1 }] }))
          // setPreviews([...previews, { email: msg, previewNumber: previewNo + 1 }])
          dispatch(setPreviewNo(previewNo + 1))
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
  }

  const displayContent = () => {
    let result = ""
    if (selectedTabData.label !== 'Email') {
      let content = tabState.find(i => i.stepNumber === previewFollowUpNo + 1)?.email;
      result = content ? updateCampaignPlaceholderValues(content, true) : '';
    } else {

      if (previewNo === 1) {
        let content = selectedTabData.email 
        result = content ? updateCampaignPlaceholderValues(content, true) : ''
      }
      else {
        let content = previews?.find((i: PreviewType) => i.previewNumber === previewNo)?.email
        result = content ? updateCampaignPlaceholderValues(content, true) : ''
      }
    }

    result = replaceDetails(result, jobTitle, minExperience, maxExperience, selectedTabData?.candidateFullName)

    return result
  }

  const getJobDescription = () => {
    const result = replaceDetails(jobDescription, jobTitle, minExperience, maxExperience, selectedTabData?.candidateFullName);
    return result;
  }

  const url = window.location.hostname;

  React.useEffect(() => {
    if(!url) return;
    setDomain(getFounditDomain(url));
  },[url])

  const PreviewBanner = (media && media.cover) ? <img width={641} style={{aspectRatio: 641/150}} src={media.cover} alt={'cover'} /> : PREVIEW_BANNER;

  const CustomButton = styled(Button)`
    max-width: 106px;
    max-height: 36px;
    min-width: 106px;
    min-height: 36px;
    padding: 8px 12px;
    text-transform: capitalize;
    font-size: 14px;
    font-family: "Noto Sans";
    font-weight: 600;
    line-height: 20px;
    border: 1px solid #6E00BE;
  `
  return (
    <Container>
      <Title>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>{selectedTabData.label === 'Email' ? 'Email Preview' : 'Follow-ups Preview'}</div>

        {!(isBulk && selectedTabData.label === 'Email') && (!!contentPersonalisationGenratedViaAI || selectedTabData.label !== 'Email') && (
          <div style={{ gap: '8px', fontFamily: 'Noto Sans', fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '24px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

            <div>{selectedTabData.label === 'Email' ? 'Email' : 'Follow-ups'}</div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div>{selectedTabData.label === 'Email' ? previewNo : previewFollowUpNo}</div>
              <div style={{ color: '#A5A3AE' }}>{selectedTabData.label !== 'Email' ? `/${tabState.length - 1}` : '/' + contactableCount}</div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ cursor: 'pointer' }} onClick={() => handlePreviewNavigate('prev')}>
                {(selectedTabData.label === 'Email' ? previewNo === 1 : previewFollowUpNo === 1) ? LEFT_DISABLED : LEFT_ENABLE}
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => handlePreviewNavigate('next')}>
                {(selectedTabData.label === 'Email' ? ((previewNo !== contactableCount) && contentPersonalisationGenratedViaAI) : ((previewFollowUpNo !== 4) && (previewFollowUpNo !== tabState.length - 1))) ? RIGHT_ENABLE : RIGHT_DISABLED}
              </div>
            </div>

          </div>
        )}

      </Title>
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap"
        rel="stylesheet"
      />
      <title>Mailer</title>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n@import url(http://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900);\n* {\n\tbox-sizing: border-box!important;\n}\n\nbody{ background-color:#F8F8F8 !important;}\nimg.g-img + div {display:none;}\n.img-responsive {width: 100%; height: auto;}\n.img-responsive1 {width: auto; height: 100%;}\n.border-right{border-right:solid 2px #e1e1e1; }\n\n@media only screen and (max-width: 468px) {\n\t.padng{ padding:10px !important;}\n\t.padng-2{ padding:5px!important;}\t\n\t.padng-3{ padding:10px 0px!important;}\t\t\n\t.margn{ margin:0 auto;}\n\t.img-responsive {width: 100%; height: auto;}\n\t.img-responsive1 {width: 100%; height: auto;}\n\t.border-right{border-right:solid 0px #e1e1e1; border-bottom:solid 3px #e1e1e1;}\n\t.m-center{text-align:center;}\n\t.fullwidth{ width:100% !important; display:table !important;}\n\t.m-font{font-size: 28px !important; line-height: 35px!important;}\n\t.m-font-2{font-size: 20px !important;}\t\n\t.m-font-3{font-size: 16px !important;}\n\t.no-padng{padding:0px!important;}\t\n\t.w-eighty{width:80%!important;}\t\t\n\t.w-twenty{width:20%!important;}\t\t\n\t.w-fifty{width:100%!important; height:auto}\t\n\t.m-width{width:2px!important; height:50px;}\n\t.m-corner-l{border-radius:0px 0px 15px 0px!important}\t\n\t.m-corner-r{border-radius:0px 0px 0px 15px!important}\n\t.boder-bottom{border-right:0px!important; border-bottom:solid 2px #44D9C1!important}\t\n\t.padng-outer{padding:0px 8px!important; border-left: solid 2px #e1e1e1!important; border-right: solid 2px #e1e1e1!important;}\t\t\n}\n\n@media only screen and (max-width: 430px) {\n\t.padng{ padding:10px !important;}\n\t.padng-2{ padding:5px!important;}\t\n\t.padng-3{ padding:10px 0px!important;}\t\t\t\n\t.margn{ margin:0 auto;}\n\t.img-responsive {width: 100%; height: auto;}\n\t.img-responsive1 {width: 100%; height: auto;}\n\t.border-right{border-right:solid 0px #e1e1e1; border-bottom:solid 3px #e1e1e1;}\n\t.m-center{text-align:center;}\n\t.fullwidth{ width:100% !important; display:table !important;}\n\t.m-font{font-size: 28px !important; line-height: 35px!important;}\n\t.m-font-2{font-size: 20px !important;}\t\n\t.m-font-3{font-size: 16px !important;}\n\t.no-padng{padding:0px!important;}\n\t.w-eighty{width:80%!important;}\t\t\n\t.w-twenty{width:20%!important;}\t\t\n\t.w-fifty{width:100%!important; height:auto}\n\t.m-width{width:2px!important; height:50px;}\n\t.m-corner-l{border-radius:0px 0px 15px 0px!important}\t\n\t.m-corner-r{border-radius:0px 0px 0px 15px!important}\n\t.boder-bottom{border-right:0px!important; border-bottom:solid 2px #44D9C1!important}\t\t\t\t\t\t\n\t\n}\n@media only screen and (max-width: 400px) {\n\t.padng{ padding:10px !important;}\n\t.padng-2{ padding:5px!important;}\t\n\t.padng-3{ padding:10px 0px!important;}\t\t\t\n\t.margn{ margin:0 auto;}\n\t.img-responsive {width: 100%; height: auto;}\n\t.img-responsive1 {width: 100%; height: auto;}\n\t.border-right{border-right:solid 0px #e1e1e1; border-bottom:solid 3px #e1e1e1;}\n\t.m-center{text-align:center;}\n\t.fullwidth{ width:100% !important; display:table !important;}\n\t.m-font{font-size: 28px !important; line-height: 35px!important;}\n\t.m-font-2{font-size: 20px !important;}\t\n\t.m-font-3{font-size: 16px !important;}\n\t.no-padng{padding:0px!important;}\t\n\t.w-eighty{width:80%!important;}\t\t\n\t.w-twenty{width:20%!important;}\t\t\t\n\t.w-fifty{width:100%!important; height:auto}\n\t.m-width{width:2px!important; height:50px;}\n\t.m-corner-l{border-radius:0px 0px 15px 0px!important}\t\n\t.m-corner-r{border-radius:0px 0px 0px 15px!important}\t\n\t.boder-bottom{border-right:0px!important; border-bottom:solid 2px #44D9C1!important}\t\t\t\t\t\t\t\t\n\t.link{font-size:17px!important;}\t\t\t\t\n}\n@media only screen and (max-width: 340px) {\n\t.padng{ padding:10px !important;}\n\t.padng-2{ padding:5px!important;}\t\n\t.padng-3{ padding:10px 0px!important;}\t\t\t\n\t.margn{ margin:0 auto;}\n\t.img-responsive {width: 100%; height: auto;}\n\t.img-responsive1 {width: 100%; height: auto;}\n\t.border-right{border-right:solid 0px #e1e1e1; border-bottom:solid 3px #e1e1e1;}\n\t.m-center{text-align:center;}\n\t.fullwidth{ width:100% !important; display:table !important;}\n\t.m-font{font-size: 28px !important; line-height: 35px!important;}\n\t.m-font-2{font-size: 20px !important;}\t\n\t.m-font-3{font-size: 16px !important;}\n\t.no-padng{padding:0px!important;}\t\n\t.w-eighty{width:80%!important;}\t\t\n\t.w-twenty{width:20%!important;}\t\t\t\t\n\t.w-fifty{width:100%!important; height:auto}\n\t.m-width{width:2px!important; height:50px;}\n\t.m-corner-l{border-radius:0px 0px 15px 0px!important}\t\n\t.m-corner-r{border-radius:0px 0px 0px 15px!important}\t\t\t\t\n\t.link{font-size:17px!important;}\t\t\t\t\n}\n\n"
        }}
      />
      <table
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{
          background: "#fafafa",
          fontFamily: 'Noto Sans',
        }}
      >
        <tbody>
          <tr>
            <td>
              <table
                width={602}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                align="center"
                style={{
                  width: "100%",
                  maxWidth: "602px !important",
                  padding: 0,
                  fontFamily: '"Poppins", sans-serif',
                  tableLayout: "fixed",
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ margin: 0, padding: 0 }}>
                      <table
                        width="100%"
                        border={0}
                        cellSpacing={0}
                        cellPadding={0}
                      >
                        <tbody>
                          <tr>
                            <td style={{padding: '10px 16px 0px 10px'}}>
                              {(!media || !media.cover) ?
                                <EmailHeading>
                                  {companyName}
                                </EmailHeading>
                                : null
                              }
                              {PreviewBanner}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ padding: "16px 34px 0 34px", backgroundColor: '#FFFFFF' }}
                              className="padng m-font-3"
                            >
                              <table
                                width="100%"
                                border={0}
                                cellSpacing={0}
                                cellPadding={0}
                              >
                                <tbody>
                                  <tr>
                                    {tabState[0].applyButton &&
                                      <td width={115}>
                                        <CustomButton variant="contained">Apply</CustomButton>
                                      </td>}
                                    {tabState[0].replyButton &&
                                      <td>
                                        <CustomButton variant="outlined">Reply</CustomButton>
                                      </td>}
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="padng m-font-3"
                              style={{
                                padding: "16px 34px",
                                fontSize: '1.4rem',
                                color: "#353535",
                                backgroundColor: '#FFFFFF',
                                lineHeight: '2.2rem'
                              }}
                              // dangerouslySetInnerHTML={{ __html: previewNo === 1 ? selectedTabData.email : (previews.find((i: PreviewType) => i.previewNumber === previewNo).email) }}
                              dangerouslySetInnerHTML={{ __html: displayContent() }}
                            >
                            </td>
                          </tr>
                        {jobDescription && (selectedTab == 'Email') && (
                          <tr>
                            <td
                              className="padng m-font-3"
                              style={{
                                padding: "16px 34px",
                                fontSize: 14,
                                color: "#353535",
                                backgroundColor: '#FFFFFF'
                              }}
                              dangerouslySetInnerHTML={{ __html: getJobDescription() }}
                            >
                            </td>
                          </tr>
                        )}
                        {!!signature && (
                          <tr>
                            <td
                              className="padng m-font-3"
                              style={{
                                padding: "16px 34px",
                                fontSize: 14,
                                color: "#353535",
                                backgroundColor: '#FFFFFF'
                              }}
                              dangerouslySetInnerHTML={{ __html: signature }}
                            > 
                            </td>
                          </tr>
                        )}
                          <tr>
                            <td
                              style={{ padding: "0px 34px", backgroundColor: '#FFFFFF' }}
                              className="padng m-font-3"
                            >
                              <table
                                width="100%"
                                border={0}
                                cellSpacing={0}
                                cellPadding={0}
                              >
                                <tbody>
                                  <tr>
                                    {tabState[0].applyButton &&
                                      <td width={115}>
                                        <CustomButton variant="contained">Apply</CustomButton>
                                      </td>}
                                    {tabState[0].replyButton &&
                                      <td>
                                        <CustomButton variant="outlined">Reply</CustomButton>
                                      </td>}
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ padding: "16px 34px", backgroundColor: '#FFFFFF' }}
                              className="padng m-font-3"
                            >
                              <table
                                width="100%"
                                border={0}
                                cellSpacing={0}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ fontSize: 16 }}>
                                      Job Information
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table
                                width="100%"
                                border={0}
                                cellSpacing={0}
                              >
                                <tbody style={{ fontSize: 14, fontWeight: 400 }}>
                               {jobTitle ? 
                               <tr>
                                    <td
                                      width={108}
                                      valign="top"
                                      style={{color: COLOR_MAP.GREY_3}}
                                    >
                                      Designation:
                                    </td>
                                    <td valign="top" style={{color: COLOR_MAP.GREY_2}}>
                                      {jobTitle}
                                      <br />
                                    </td>
                                  </tr>
                                : null  
                                }
                                 {(minExperience || maxExperience) ?
                                 <tr>
                                    <td width={130} valign="top" style={{color: COLOR_MAP.GREY_3}} >
                                      Experience:
                                    </td>
                                    {
                                      (minExperience === '0' && maxExperience === '0') ? 
                                      <td valign="top" style={{color: COLOR_MAP.GREY_2}}>
                                        Fresher job
                                      <br />
                                    </td>
                                      :
                                      <td valign="top" style={{color: COLOR_MAP.GREY_2}}>
                                      {minExperience}&nbsp; to &nbsp;{maxExperience} {Number(maxExperience) <= 1 ? 'year' : 'years'}
                                      <br />
                                    </td>
                                    }
                                  </tr>
                                   : null
                                  }
                                  {
                                    (minSalary && !maxSalary) ?
                                    <tr>
                                    <td valign="top" style={{color: COLOR_MAP.GREY_3}}>
                                     Salary:
                                    </td>
                                    {
                                      currency !== "INR" ?
                                        <td valign="top" style={{color: COLOR_MAP.GREY_2}}>Minimum&nbsp;{currencySymbol}&nbsp;{minSalary}&nbsp;per month</td>
                                        :
                                        <td valign="top" style={{color: COLOR_MAP.GREY_2}}>Minimum&nbsp;₹&nbsp;{minSalary.replace('₹','')}&nbsp;per annum</td>
                                    }
                                  </tr>
                                : null  
                                  }
                                     {
                                    (maxSalary && !minSalary) ?
                                    <tr>
                                    <td valign="top" style={{color: COLOR_MAP.GREY_3}}>
                                     Salary:
                                    </td>
                                    {
                                       currency !== "INR" ?
                                      <td valign="top"  style={{color: COLOR_MAP.GREY_2}}>Up to&nbsp;{currencySymbol}&nbsp;{maxSalary}&nbsp;per month
                                    </td>
                                      :
                                      <td valign="top"  style={{color: COLOR_MAP.GREY_2}}>Up to&nbsp;₹&nbsp;{maxSalary.replace('₹','')}&nbsp;per annum
                                    </td>
                                    }
                                  </tr>
                                : null  
                                  }
                                 {(minSalary && maxSalary) ?
                                  <tr>
                                    <td valign="top" style={{color: COLOR_MAP.GREY_3}}>
                                     Salary:
                                    </td>
                                   {
                                     currency !== "INR" ?
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_2}}>{currencySymbol}&nbsp;{minSalary}&nbsp; to &nbsp;{currencySymbol}&nbsp;{maxSalary}&nbsp;per month
                                    </td>
                                    :
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_2}}>₹&nbsp;{minSalary.replace('₹', '')}&nbsp; to &nbsp;₹&nbsp;{maxSalary.replace('₹','')}&nbsp;per annum
                                    </td>
                                   }
                                  </tr>
                                : null  
                                }
                                 {(jobMode !== 'Remote' &&  jobLocations.length)  ?  (<tr>
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_3}}>
                                      Location:
                                    </td>
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_2}}>
                                      {
                                        jobLocations?.length ?
                                        jobLocations.map((item: string, index: any) => item + (index === jobLocations.length - 1 ? '' : ', '))
                                          : null
                                      }
                                    </td>
                                  </tr>)
                                : null  
                                }
                                  <tr>
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_3}}>
                                      Job mode:
                                    </td>
                                    <td valign="top"  style={{color: COLOR_MAP.GREY_2, fontSize: 16}}>
                                      {jobMode === 'WFO' ? 'WFO (Work From Office)' : jobMode}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                padding: "16px 34px",
                                borderTop: "solid 1px #E7E7EA",
                                fontSize: 12,
                                fontWeight: 400,
                                color: COLOR_MAP.GREY_3,
                                backgroundColor: '#FFFFFF'
                              }}
                              className="padng m-font-3"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: '16px'
                                }}
                              >
                                {(media && media.logo) ?
                                  <img
                                    src={media.logo}
                                    alt="company-logo"
                                    style={{
                                      border: "1px solid #E7E7EA",
                                      borderRadius: "4px",
                                      height: "auto",
                                      width: "auto",
                                      maxWidth:"160px",
                                      maxHeight: "60px"
                                    }}
                                  />
                                  : null
                                }
                                <div style={{display: 'flex', alignItems:'center'}}>
                                  <strong style={{ fontSize: 14, fontWeight: 600, color: COLOR_MAP.GREY_0 }}>
                                    {companyName}
                                  </strong>
                                  {/* <br />
                                  <div style={{marginTop: '8px'}}>
                                  Followers(15291) | Active Jobs(2)
                                  </div> */}
                                </div>
                              </div>
                              <br />
                              About {companyName}
                              <br />
                              {aboutCompany}{" "}
                            </td>
                          </tr>
                          {/* <tr>
                            <td style={{ padding: 0, backgroundColor: '#FFFFFF' }}>
                              <img
                                src="https://media.monsterindia.com/newsletter/240723_va_Previ-16283619_MI/banner.jpg"
                                width={593}
                                height={95}
                                style={{ display: "block" }}
                                className="img-responsive"
                              />
                            </td>
                          </tr> */}
                          <tr style={{  
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '##17142A'
                          }}>
                            <td style={{display:'flex', alignItems:'end'}}>{<AppDownloadBanner />}</td>
                            
                          </tr>
                          <tr style={{height: '5px'}} />
                          <tr
                          style={{
                            fontSize: '14px',
                          fontWeight: 400,
                          color: '#59566C',
                          borderTop: '1px solid #BABDDB',
                           borderBottom: '1px solid #BABDDB'

                          }}
                          >
                            <td
                             style={{
                              padding: '8px 16px', 
                              backgroundColor: COLOR_MAP.LAVENDER_PRIMARY,
                              textAlign: 'center'
                              }}>
                                Increase your chances of getting a job by keeping your resume up-to-date.
                                <p style={{fontWeight: 600, color:COLOR_MAP.DARK_PURPLE , margin: '10px 0px 0px 0px'}}>Update your resume here</p>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                padding: '16px 34px',
                                fontSize: 12,
                                fontWeight: 400,
                                color: "#A5A3AE",
                                backgroundColor: '#FFFFFF'
                              }}
                            >
                              This mail has been sent by one of the employers
                              (Employer name: {originalCompanyName}) accessing the services of{" "}
                                <strong  style={{ color: "#6E00BE" }}>{domain}</strong>
                                {" "}
                              and not by foundit. foundit is committed to protecting
                              the privacy of our users and our "Terms of Use"
                              prohibits any misuse including spamming.
                              <br />
                              <br />
                              foundit always recommends jobseekers to be alert &amp;
                              verify the legitimacy of those
                              employers/consultants/individuals seeking any kind of
                              monetary/ financial considerations from the jobseekers
                              for any job offer(s) and also be cautious towards any
                              job appointment confirmation without any interview.
                              Please beware of agencies/individuals/consultants
                              seeking money for any job offer claiming to be from
                              well-known Brands/Employers/Companies.
                              <br />
                              <br />
                              If you consider the contents of the mails
                              inappropriate or as spam, please forward this mail to{" "}
                             
                                <strong style={{ color: "#6E00BE" }}>spam@{domain}</strong>
                            
                              <br />
                              <br />
                              (While sending a reply, please don't delete or modify
                              the original content, OR ensure the code "Source:
                              foundit" is included in the mail's subject line)
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  )
}


export default PreviewEmail;
